// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__xcdeW","icon":"Chip_icon__+ZF6n","label":"Chip_label__GN9aR"};